import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {Input} from '../../components/Input';
import { db, getCurrentUser, Timestamp } from '../../firebase';

const PRICING_FORM_FIELDS  = [
  {
    key: 'emergencyBounty',
    display: 'Emergency',
    required: true,
    type: 'number',
  },
  {
    key: 'repairBounty',
    display: 'Repair',
    required: true,
    type: 'number',
  },
  {
    key: 'missingBounty',
    display: 'Missing',
    required: true,
    type: 'number',
  },
  {
    key: 'regularBounty',
    display: 'Regular',
    required: true,
    type: 'number',
  },
];


class PricingForMarket extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      pricingDoc: null,
    }
  }

  componentDidMount = async () => {
    const {market} = this.props.match.params;
    const pricingDoc = await db.collection('streetTeamPricing').doc(market).get()

    const state = {
      isLoading: false,
      pricingDoc,
    };

    PRICING_FORM_FIELDS.forEach(({key}) => {
      const currentValue = pricingDoc.data()[key];

      state[key] = currentValue;
    })

    this.setState(state)
  }

  updateMarketPricing = async (e) => {
    e.preventDefault();

    const {market} = this.props.match.params;
    const updatedAt = Timestamp.now();
    const updatedByUserEmail = getCurrentUser().email;

    const attrs = _.fromPairs(
      PRICING_FORM_FIELDS.map(
        ({key}) => [key, this.state[key]]
      )
    );

    await db.collection('streetTeamPricing').doc(market).update({
      updatedAt,
      updatedByUserEmail,
      ...attrs,
    })

    this.props.history.push('/admin/pricing');
  }

  render() {
    const {market} = this.props.match.params;
    const {isLoading} = this.state;

    if (isLoading) {
      return <div>Loading pricing...</div>;
    }

    return (
      <div className='container-fluid'>
        <div className='row'>
          <div className='col'>
            <h3>Pricing for {market}</h3>
        
            <form onSubmit={this.updateMarketPricing}>
              {PRICING_FORM_FIELDS.map((fieldInfo) => (
                <Input
                  updateValue={(new_value) => this.setState({[fieldInfo.key]: new_value})}
                  value={this.state[fieldInfo.key]}
                  fieldKey={fieldInfo.key}
                  {...fieldInfo}
                />
              ))} 

              <button className='btn btn-primary' type='submit'>
                Update pricing
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

PricingForMarket.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      market: PropTypes.string.isRequired,
    }).isRequired
  }).isRequired
};

export {PricingForMarket};


// WEBPACK FOOTER //
// ./src/street-team/admin/PricingForMarket.js